import { useCallback } from 'react'
import { useTranslations } from '@npco/utils-translations'
import {
  AnnouncementModal,
  SvgIcon,
  useIsMobileResolution,
} from '@npco/zeller-design-system'

import { ReactComponent as CardAdded } from '../../../../../assets/svg/graphics/card-added.svg'
import { IllustrationWithPill } from '../../../../CCOutstandingExpenseComingSoon/cc-outstanding-expense-coming-soon/CCOutstandingExpenseComingSoonModal/components/InvoiceIllustrationWithPill/InvoiceIllustrationWithPill'
import { useGoToOutstandingTransactionsComingSoon } from '../../../outstanding-transactions-coming-soon-routing/hooks/useGoToOutstandingTransactionsComingSoon/useGoToOutstandingTransactionsComingSoon'
import { outstandingTransactionsComingSoonModalContentTranslations } from './OutstandingTransactionsComingSoonModalContent.i18n'

export const OutstandingTransactionsComingSoonModalContent = () => {
  const t = useTranslations(
    outstandingTransactionsComingSoonModalContentTranslations
  )
  const { goToOutstandingTransactionsComingSoon } =
    useGoToOutstandingTransactionsComingSoon()
  const isMobile = useIsMobileResolution()
  const illustrationSize = isMobile ? '140' : '180'

  const closeModal = useCallback(() => {
    goToOutstandingTransactionsComingSoon(null)
  }, [goToOutstandingTransactionsComingSoon])

  return (
    <AnnouncementModal
      Illustration={
        <IllustrationWithPill
          illustration={
            <SvgIcon width={illustrationSize} height={illustrationSize}>
              <CardAdded />
            </SvgIcon>
          }
        />
      }
      heading={t('title')}
      description={t('description')}
      primaryButtonLabel={t('actionButton')}
      onClickPrimary={closeModal}
      onCancel={closeModal}
      isOpen
    />
  )
}
